import src from "IMAGE";
export default { src, width: 251, height: 602, blurWidth: 3, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAICAYAAAA870V8AAAAO0lEQVR42lWKOQ6AMAwEx7S2XPn6/0uBiEikmD20i6piZrg7RASZSVWx5EPobmZGHpcVNu8im7P8btcNKvoGI2QNtyAAAAAASUVORK5CYII="};
